const gridLayouts = [
  { id: '1x1', name: '1x1', rows: 1, cols: 1, icon: '1×1', areas: [{ x: 0, y: 0, w: 1, h: 1 }] },
  { id: '1x2', name: '1x2', rows: 1, cols: 2, icon: '1×2', areas: [{ x: 0, y: 0, w: 1, h: 1 }, { x: 1, y: 0, w: 1, h: 1 }] },
  { id: '1x3', name: '1x3', rows: 1, cols: 3, icon: '1×3', areas: [{ x: 0, y: 0, w: 1, h: 1 }, { x: 1, y: 0, w: 1, h: 1 }, { x: 2, y: 0, w: 1, h: 1 }] },
  { id: '2x1', name: '2x1', rows: 2, cols: 1, icon: '2×1', areas: [{ x: 0, y: 0, w: 1, h: 1 }, { x: 0, y: 1, w: 1, h: 1 }] },
  { id: '2x2', name: '2x2', rows: 2, cols: 2, icon: '2×2', areas: [
    { x: 0, y: 0, w: 1, h: 1 }, { x: 1, y: 0, w: 1, h: 1 },
    { x: 0, y: 1, w: 1, h: 1 }, { x: 1, y: 1, w: 1, h: 1 }
  ]},
  { id: '2x3', name: '2x3', rows: 2, cols: 3, icon: '2×3', areas: [
    { x: 0, y: 0, w: 1, h: 1 }, { x: 1, y: 0, w: 1, h: 1 }, { x: 2, y: 0, w: 1, h: 1 },
    { x: 0, y: 1, w: 1, h: 1 }, { x: 1, y: 1, w: 1, h: 1 }, { x: 2, y: 1, w: 1, h: 1 }
  ]},
  { id: '3x1', name: '3x1', rows: 3, cols: 1, icon: '3×1', areas: [{ x: 0, y: 0, w: 1, h: 1 }, { x: 0, y: 1, w: 1, h: 1 }, { x: 0, y: 2, w: 1, h: 1 }] },
  { id: '3x2', name: '3x2', rows: 3, cols: 2, icon: '3×2', areas: [
    { x: 0, y: 0, w: 1, h: 1 }, { x: 1, y: 0, w: 1, h: 1 },
    { x: 0, y: 1, w: 1, h: 1 }, { x: 1, y: 1, w: 1, h: 1 },
    { x: 0, y: 2, w: 1, h: 1 }, { x: 1, y: 2, w: 1, h: 1 }
  ]},
  { id: 'hetero1', name: '上2下1', rows: 2, cols: 2, icon: '上2下1', isHeterogeneous: true, areas: [
    { x: 0, y: 0, w: 1, h: 1 }, { x: 1, y: 0, w: 1, h: 1 }, { x: 0, y: 1, w: 2, h: 1 }
  ]},
  { id: 'hetero2', name: '左2右1', rows: 2, cols: 2, icon: '左2右1', isHeterogeneous: true, areas: [
    { x: 0, y: 0, w: 1.5, h: 1 }, { x: 0, y: 1, w: 1.5, h: 1 }, { x: 1.5, y: 0, w: 0.5, h: 2 }
  ]},
  { id: 'hetero3', name: '上1下2', rows: 2, cols: 2, icon: '上1下2', isHeterogeneous: true, areas: [
    { x: 0, y: 0, w: 2, h: 1 }, { x: 0, y: 1, w: 1, h: 1 }, { x: 1, y: 1, w: 1, h: 1 }
  ]},
  { id: 'hetero4', name: '左1右2', rows: 2, cols: 2, icon: '左1右2', isHeterogeneous: true, areas: [
    { x: 0, y: 0, w: 0.5, h: 2 }, { x: 0.5, y: 0, w: 1.5, h: 1 }, { x: 0.5, y: 1, w: 1.5, h: 1 }
  ]}
];

export default gridLayouts;